<!--
	TEMPLATE
-->
<template>
<div class="editable-inputs">
	<div v-if="!isEditView">
		<p v-if="inputs.length === 1 && inputs[0] === ''" class="text-italic">None</p>
		<p v-else v-for="input in inputs">{{ input }}</p>
	</div>

	<div v-if="isEditView" class="editable-inputs__edit">
		<repeatable-inputs @hasErrors="hasErrors = arguments[0]" v-model="inputs" :rules="options.rules" :type="options.type" :name="options.name" :placeholder="options.placeholder" :inputmode="options.inputmode" :link-name="options.linkName" imageLink="TrashCan_White" :scopeName="options.scopeName"></repeatable-inputs>
	</div>
</div>
</template>

<!--
	SCRIPT
-->
<script>
import vModelNested from '@/libs/vModelNested.js';
import RepeatableInputs from '../RepeatableInputs.vue';

export default {
	props: {
		value: {
			 type: Array,
			 default: function() {
 				return ['']
 			}
		},
		options: Object,
		isEditView: Boolean
	},
	data: function() {
		return {
			hasErrors: false
		}
	},
	components: {
		'repeatable-inputs': RepeatableInputs
	},
	watch: {
		hasErrors: function() {
		  this.$emit('hasErrors', this.hasErrors);
	  }
	},
	computed: {
		inputs: vModelNested
	}
}
</script>



// WEBPACK FOOTER //
// src/components/editable-items/EditableRepeatableInputs.vue